export default "/static/assets/hg-logo-blue.eae534634c7d412ed5b90c480af68c12.svg";